import NewTagDialog from "./newTagDialog.container";

export default NewTagDialog;
